import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import StickyContact from './components/StickyContact';
import Home from './pages/Home';

function App() {
  return (
    <HelmetProvider>
      <Navbar />
      <Home />
      <StickyContact />
      <Footer />
    </HelmetProvider>
  );
}

export default App;
